import React, { useContext } from 'react'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'

import { useAllTimeHelpers } from './helpers'
import { HourNumber, HourStyleProps, StyledButton } from './styles'

type Props = {
  index: number
}

export const Hour: React.FC<Props> = React.memo(function Hour({ index }) {
  const {
    setDateTimeState,
    dateTimeState: {
      props: { onChange },
      value,
    },
  } = useContext(DateTimePickerContext)
  const { hour, isSelected, isDisabled } = useAllTimeHelpers(index)

  const handleHourClick = () => {
    setDateTimeState((state) => ({
      ...state,
      value: { ...state.value, time: hour },
    }))

    if (onChange) {
      const { day, month, year } = value
      if (day !== undefined && month !== undefined && year !== undefined) {
        onChange({ day, month, year, time: hour })
      } else {
        console.debug("onChange handler in Timepicker didn't fire, because Datepicker input is invalid")
      }
    }
  }

  const stylingProps: HourStyleProps = {
    isSelected,
    isDisabled: isDisabled,
  }

  return (
    <StyledButton onClick={handleHourClick} {...stylingProps}>
      <HourNumber fontSize="md" {...stylingProps}>
        {hour}:00
      </HourNumber>
    </StyledButton>
  )
})
